import { SVGProps } from "react";

export const SquaredError = (props: SVGProps<SVGSVGElement>) => {
  const fillColor = props.color ?? "#E03E32";
  const { color: _color, ...rest } = props;

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M24 27.5C23.18 27.5 22.5 26.82 22.5 26V15.5C22.5 14.68 23.18 14 24 14C24.82 14 25.5 14.68 25.5 15.5V26C25.5 26.82 24.82 27.5 24 27.5Z"
        fill={fillColor}
      />
      <path
        d="M24 34.5004C23.46 34.5004 22.96 34.3005 22.58 33.9205C22.4 33.7205 22.26 33.5004 22.14 33.2604C22.04 33.0204 22 32.7604 22 32.5004C22 31.9804 22.22 31.4604 22.58 31.0804C23.32 30.3404 24.68 30.3404 25.42 31.0804C25.78 31.4604 26 31.9804 26 32.5004C26 32.7604 25.94 33.0204 25.84 33.2604C25.74 33.5004 25.6 33.7205 25.42 33.9205C25.04 34.3005 24.54 34.5004 24 34.5004Z"
        fill={fillColor}
      />
      <path
        d="M24.0004 45.5002C22.6604 45.5002 21.3003 45.1602 20.1003 44.4602L8.22034 37.6002C5.82034 36.2002 4.32031 33.6202 4.32031 30.8402V17.1602C4.32031 14.3802 5.82034 11.8002 8.22034 10.4002L20.1003 3.54023C22.5003 2.14023 25.4804 2.14023 27.9004 3.54023L39.7804 10.4002C42.1804 11.8002 43.6804 14.3802 43.6804 17.1602V30.8402C43.6804 33.6202 42.1804 36.2002 39.7804 37.6002L27.9004 44.4602C26.7004 45.1602 25.3404 45.5002 24.0004 45.5002ZM24.0004 5.5002C23.1804 5.5002 22.3403 5.72021 21.6003 6.14021L9.72034 13.0002C8.24034 13.8602 7.32031 15.4402 7.32031 17.1602V30.8402C7.32031 32.5402 8.24034 34.1402 9.72034 35.0002L21.6003 41.8602C23.0803 42.7202 24.9204 42.7202 26.3804 41.8602L38.2604 35.0002C39.7404 34.1402 40.6604 32.5602 40.6604 30.8402V17.1602C40.6604 15.4602 39.7404 13.8602 38.2604 13.0002L26.3804 6.14021C25.6604 5.72021 24.8204 5.5002 24.0004 5.5002Z"
        fill={fillColor}
      />
    </svg>
  );
};
